import { useIntegrationStore, INTEGRATIONS } from '@/stores/integration';
import { useToast } from '@dashhudson/dashing-ui';
import { env } from '@/env';

const WORKFLOWS = {
  UPLOAD_MEDIA: 'a9a83750-344b-4857-ba64-5d1d5900a17a',
};

const DEV_WORKFLOWS = {
  UPLOAD_MEDIA: 'a9a83750-344b-4857-ba64-5d1d5900a17a',
};

export const useCanva = () => {
  const { addToast } = useToast({ life: 5000 });
  const integrationStore = useIntegrationStore();

  async function sendMedia(mediaList: Array<{ name: string; url: string }>): Promise<void> {
    if (!integrationStore.isConnected(INTEGRATIONS.BRAND.CANVA.value)) {
      integrationStore.connect(INTEGRATIONS.BRAND.CANVA.value);
      return;
    }
    const workflowId = env.isProduction ? WORKFLOWS.UPLOAD_MEDIA : DEV_WORKFLOWS.UPLOAD_MEDIA;
    try {
      await integrationStore.runWorkflow(workflowId, { body: { mediaObj: mediaList } });
      addToast({
        message: 'Uploading to Images in Canva Projects. This may take a few moments',
        severity: 'success',
      });
    } catch {
      addToast({
        message: 'Something went wrong. Please try again later!',
        severity: 'error',
      });
    }
  }

  return {
    sendMedia,
  };
};
